import { connect } from "react-redux";
import { useWindowSize } from "../../../hooks/useWindowSize";
import "react-datepicker/dist/react-datepicker.css";
import { InAppTemplate } from "../../../shared/templates/inapp";
import "../../../scss/products.scss";
import { storeActions } from "../../../redux/actions/in-app";
import { InAppContent } from "../../../views/Inapp/products/InAppContent";

const ProductList = (pageProps: any) => {
  const screenResolution: any = useWindowSize();
  return (
    <InAppTemplate
      isWide={screenResolution?.width <= 1024 ? true : false}
      pageHeadingTitle="My Products"
      childComponent={<InAppContent pageProps={pageProps} />}
    />
  );
};

const mapDispatchToProps = {
  getMetadataAction: storeActions.GetProductMetaData,
  getMyProductList: storeActions.GetMyProductList,
  toggleAProduct: storeActions.ToggleAProduct,
  bulkProductUpdate: storeActions.BulkProductUpdate,
  deleteStoreProduct: storeActions.DeleteStoreProduct,
  permanentDeleteProduct: storeActions.PermanentDeleteProduct,
};

const mapStateToProps = (state: any) => ({
  getProductMetaDataRequest: state.allProductReducers.getProductMetaDataReducer,
  getProductListRequest: state.allProductReducers.getProductListReducer,
  toggleProductRequest: state.allProductReducers.toggleProductReducer,
  bulkProductUpdateRequest: state.allProductReducers.bulkProductUpdateReducer,
  deleteStoreProductRequest: state.allProductReducers.deleteStoreProductReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
